import React from 'react'
import ApartmentSignUp from '../feature/Login/ApartmentSignUp'

const ApartmentSignUpPage = () => {
  return <ApartmentSignUp/>
}

export default ApartmentSignUpPage